import {
  Box,
  Button,
  Disclaimer,
  Icon,
  Modal,
  P,
  PropsModal,
  TrashIconRed,
  agentImage,
  lightTheme,
} from '@vgrubs/components';
import { LocationAgent } from 'components/src/types/api/location.types';
import { AGENT_SERVICES, isAgentOnService } from './useLocationAgents';
import { NoDataComponent } from 'components/src/adminComponents/NoDataComponent/NoDataComponent';

export const LocationAgentsModal = ({
  modalIsOpen,
  closeModal,
  agents,
  onAdd,
  onDelete,
}: PropsModal & {
  modalIsOpen: boolean;
  agents: LocationAgent[];
  onAdd: () => void;
  onDelete: (agentId: number) => void;
}) => {
  const renderServices = (agent: LocationAgent) =>
    AGENT_SERVICES.filter((service) => isAgentOnService(agent, service.key))
      .map((service) => service.label)
      .join(' · ');

  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header={`Agents (${agents.length})`}
      textAlign="left"
      $numOfFloatingButtons={1}
      zIndex={110}
      footer={
        <Button $selected $w="100%" onClick={onAdd}>
          Add Agents
        </Button>
      }
    >
      {agents.length === 0 ? (
        <NoDataComponent
          image={agentImage}
          description="No agents"
          height="200px"
          heightSM="200px"
          imageWidth="100px"
          imageWidthSM="80px"
        />
      ) : (
        agents.map((agent) => {
          const services = renderServices(agent);

          return (
            <Box
              key={agent.agentId}
              $minHeight="auto"
              $mb="8"
              $flex
              $alignCenter
              $between
              $gap="16px"
            >
              <div>
                <P
                  $bold
                  $mb="2"
                  $pointer
                  $hoverUnderline
                  onClick={() =>
                    window.open(`/users/agent/${agent.userId}`, '_blank')
                  }
                >
                  {agent.name}
                </P>
                <Disclaimer $m="0" $color={lightTheme.lightGray}>
                  {services || 'No services'}
                </Disclaimer>
              </div>

              <Icon $pointer onClick={() => onDelete(agent.agentId)}>
                <TrashIconRed />
              </Icon>
            </Box>
          );
        })
      )}
    </Modal>
  );
};
